export const SET_BLOCK_USER_MODAL_VISIBILITY =
    'SET_BLOCK_USER_MODAL_VISIBILITY';

export const setBlockUserModalVisibility = (value) => {
    return {
        payload: { user: value },
        type: SET_BLOCK_USER_MODAL_VISIBILITY,
    };
};
